import { useApplicationContext } from '~/common/context';
import { useAccessControl } from '~/common/hooks';
import { ICustomer } from '~/common/types';
import { CustomerFormPrivilegesHelpers } from '~/connect/helpers';
import { CustomerFormPrivileges } from '~/connect/types';

export const useCustomerFormPrivileges = ({
  level,
  customer,
}: {
  level: number;
  customer?: ICustomer;
}): CustomerFormPrivileges => {
  const acl = useAccessControl();
  const { auth, application } = useApplicationContext();

  return CustomerFormPrivilegesHelpers.buildCustomerFormPrivileges({
    acl,
    auth,
    entities: application.entities,
    level,
    customer,
  });
};
